'use strict';

var keyMirror = require('react/lib/keyMirror');

// Define action constants
module.exports = keyMirror({
    SEARCH_ART: null,
    CLEAR_RESULT: null
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFydHdvcmsuY29uc3RhbnRzLmpzIl0sIm5hbWVzIjpbImtleU1pcnJvciIsInJlcXVpcmUiLCJtb2R1bGUiLCJleHBvcnRzIiwiU0VBUkNIX0FSVCIsIkNMRUFSX1JFU1VMVCJdLCJtYXBwaW5ncyI6Ijs7QUFBQSxJQUFJQSxZQUFZQyxRQUFRLHFCQUFSLENBQWhCOztBQUVBO0FBQ0FDLE9BQU9DLE9BQVAsR0FBaUJILFVBQVU7QUFDdkJJLGdCQUFZLElBRFc7QUFFdkJDLGtCQUFjO0FBRlMsQ0FBVixDQUFqQiIsImZpbGUiOiJhcnR3b3JrLmNvbnN0YW50cy5qcyIsInNvdXJjZXNDb250ZW50IjpbInZhciBrZXlNaXJyb3IgPSByZXF1aXJlKCdyZWFjdC9saWIva2V5TWlycm9yJyk7XG5cbi8vIERlZmluZSBhY3Rpb24gY29uc3RhbnRzXG5tb2R1bGUuZXhwb3J0cyA9IGtleU1pcnJvcih7XG4gICAgU0VBUkNIX0FSVDogbnVsbCxcbiAgICBDTEVBUl9SRVNVTFQ6IG51bGxcbn0pOyJdfQ==